import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import classNames from 'classnames';
import MaskedInput from 'react-text-mask';
import emailMask from 'text-mask-addons/dist/emailMask';

import Error from '@components/form/error';

export default function Email({ label, ...props }) {
  const [field, meta] = useField(props);

  const classes = useMemo(() => (
    classNames(
      'input__wrapper',
      { error: meta.touched && !!meta.error },
    )
  ), [field, meta]);

  return (
    <div className={classes}>
      <label>
        <span className='input__wrapper__label'>{label}</span>
        <div className='input__wrapper__input'>
          <MaskedInput
            mask={emailMask}
            type='text'
            {...field}
            {...props}
          />
        </div>
      </label>
      <Error name={field.name} />
    </div>
  );
}

Email.defaultProps = {
  label: '',
};

Email.propTypes = {
  label: PropTypes.string,
};
